import moment from 'moment';
import { useSelector } from 'react-redux';
import { getRealTimeUpdateInterval } from '../store/selectors';

const getPeriodRange = (interval, timeUnit = 'hours') => ({
  start: +moment.utc().subtract(interval, timeUnit).valueOf(),
  end: +moment.utc().valueOf(),
});

export const useRealTimeGraphUpdate = (params) => {
  const { metricPolling, values, setValues, loadMetrics, isDemo, filters } = params;
  const updateInterval = useSelector(getRealTimeUpdateInterval);
  const aggInterval = Math.floor(updateInterval / 60) >= 5 ? updateInterval : 5 * 60;

  const startPolling = () => {
    metricPolling.start(
      () => {
        const { start: historyStart, end: historyEnd } = getPeriodRange(filters.timeRange);

        setValues({ ...values, from: historyStart, to: historyEnd });
        loadMetrics({ ...values, from: historyStart, to: historyEnd }, true);
      },
      () => {
        // merge new metric to graph
        const { start, end } = getPeriodRange(aggInterval, 'seconds');

        loadMetrics({ ...values, from: start, to: end });

        // Changing graph visible period
        const { start: graphStart, end: graphEnd } = getPeriodRange(filters.timeRange);

        setValues({ ...values, from: graphStart, to: graphEnd });
      },
      updateInterval * 1000,
      isDemo,
    );
  };

  return { startPolling };
};
